// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import getColor from "@insite/mobius/utilities/getColor";
import Select, { SelectProps } from "@store/MobiusOverrides/Select/Select";
import useStepFormInputs from "@store/Library/Components/Bunzl/StepFormComponents/useStepFormInputs";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";
import StepFormTextDisplayValues from "./StepFormDisplayValues";
import { StepFormCommonProps } from "./StepFormTextField";

interface StepFormProvinceSelectProps extends Omit<SelectProps, "error">, StepFormCommonProps {}

interface StepFormProvinceSelectStyles {
    select: SelectProps;
}
const provinces = [
    translate("Ontario"),
    translate("Quebec"),
    translate("Alberta"),
    translate("British Columbia"),
    translate("Manitoba"),
    translate("New Brunswick"),
    translate("Newfoundland and Labrador"),
    translate("Nova Scotia"),
    translate("Prince Edward Island"),
    translate("Saskatchewan"),
    translate("Northwest Territories"),
    translate("Nunavut"),
    translate("Yukon"),
];

const stepFormProvinceSelectStyles: StepFormProvinceSelectStyles = {
    select: {
        labelProps: {
            size: 14,
        },
        cssOverrides: {
            descriptionWrapper: css`
                > span {
                    font-size: 12px;
                    font-weight: 400;
                }
            `,
            inputSelect: css`
                border-radius: 7px;
                font-size: 14px;
                :disabled {
                    border: none;
                    background-color: inherit;
                    svg {
                        display: none;
                    }
                }
            `,
            formInputWrapper: css`
                margin-top: 2px;

                input {
                    ::placeholder {
                        font-size: ${pxToRem(14)};
                        color: ${getColor("text.accent")};
                    }
                    font-size: 14px;
                }
                input:focus {
                    padding: 0 ${pxToRem(10)};
                    background-color: #f7feff;
                    border-color: #007185;
                    box-shadow: 0 0 0 3px #c8f3fa, 0 1px 2px rgba(15, 17, 17, 0.15) inset;
                }
            `,
            formField: css`
                width: calc(33% - 1rem);
            `,
        },
    },
};

const getSelectStyles = (value: string | undefined): SelectProps => {
    // need to use !important here otherwise styles are being overwritten by the Mobius Select component styles.
    return {
        ...stepFormProvinceSelectStyles.select,
        mergeCss: true,
        css: css`
            option[value=""][disabled] {
                color: ${getColor("text.accent")} !important;
            }
            option {
                color: black !important;
            }

            ${!value &&
            css`
                color: #a7a7a7 !important;
            `}
        `,
    };
};

const StepFormProvinceSelect: React.FC<StepFormProvinceSelectProps> = ({
    hasSubmitted,
    inputKey,
valueOverride,
    stepOverride,
    placeholder = "Select Province",
    validation,
    ...otherProps
}) => {
    const required = !!otherProps?.required;

    const { value, editable, error, handleChange } = useStepFormInputs({
        inputKey,
        required,
        validation,
        stepOverride,
        value: valueOverride,
    });
    const internalHandleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        handleChange(event.target.value);
    };
    return (
        <>
            {editable && (
                <Select
                    {...getSelectStyles(value)}
                    mergeCss
                    onChange={internalHandleChange}
                    value={value ?? ""}
                    {...otherProps}
                    error={error}
                >
                    <option value="" disabled>
                        {placeholder}
                    </option>
                    {provinces.map(province => (
                        <option key={province} value={province}>
                            {province}
                        </option>
                    ))}
                </Select>
            )}
            {!editable && (
                <StepFormTextDisplayValues
                    label={typeof otherProps.label === "string" ? otherProps.label : ""}
                    value={value ?? ""}
                    error={error}
                    variant="small"
                />
            )}
        </>
    );
};

export default StepFormProvinceSelect;
